import { render } from "./ErrorsInformation.vue?vue&type=template&id=efef99b2&scoped=true&ts=true&lang=pug"
import script from "./ErrorsInformation.vue?vue&type=script&lang=ts"
export * from "./ErrorsInformation.vue?vue&type=script&lang=ts"

import "./ErrorsInformation.vue?vue&type=style&index=0&id=efef99b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efef99b2"]])

export default __exports__